/**
 * table 组件
 */
import { Component } from '@angular/core';
import { FieldType } from '@kre-form/core';

@Component({
  selector: 'kreform-field-ion-table',
  template: `
    <ng-container>
      <ion-item>table 暂不支持</ion-item>
      <!--  不太确定展示哪些字段
        <div *ngFor="let item of to.options">
        <ion-label>{{ item.label }}</ion-label>
        <ion-item>
          <div>{{ item.value }}</div></ion-item
        >
      </div> -->
    </ng-container>
  `,
})
export class KreFormFieldIonTable extends FieldType {}
